import React from "react";
import { useNavigate } from "react-router-dom";
import { Card, Icon } from 'antd';
import SkeletonBox from "../SkeletonBox";
import CardTitle from "../CardTitle";
import { useFetchTopKeywordsOverviewQuery, useFetchTopKeywordsQuery } from "../../topKeywords/service";
import { defaultOrderBy, defaultOrderDir } from "../../topKeywords/settings";
import TopKeywordsOverview from "./TopKeywordsOverview";
import TopKeywordsTable from "./TopKeywordsTable";

type Props = {
    websiteGuid: string;
    domain: string;
    locationName: string;
    languageCode: string;
};

export default function TopKeywords({ websiteGuid, domain, locationName, languageCode }: Props) {
    const navigate = useNavigate();

    const { data: topKeywordsOverview, isLoading: isLoadingTopKeywordsOverview } = useFetchTopKeywordsOverviewQuery(
        { domain, locationName, languageCode }
    );
    const { data: topKeywords, isLoading: isLoadingTopKeywords } = useFetchTopKeywordsQuery(
        { domain, locationName, languageCode, orderBy: defaultOrderBy, orderDir: defaultOrderDir }
    );

    const isLoading = isLoadingTopKeywordsOverview || isLoadingTopKeywords;
    const hasTopKeywordsOverview = !isLoadingTopKeywordsOverview && topKeywordsOverview;

    return (
        <div className="dashboard-top-keywords-box">
            {isLoading && <SkeletonBox />}

            {!isLoading && (
                <Card
                    data-cy="top-keywords-box"
                    title={
                        <CardTitle
                            title="Top keywords"
                            description="Over the last 7 days"
                        />
                    }
                    extra={
                        <div
                            className="view-report-btn"
                            onClick={() => navigate(`/top-keywords?w_guid=${websiteGuid}`)}
                        >
                            <span>View report</span>
                            <Icon type="right" />
                        </div>
                    }
                >
                    {hasTopKeywordsOverview && <TopKeywordsOverview overview={topKeywordsOverview} />}

                    <TopKeywordsTable keywords={topKeywords ? topKeywords.slice(0, 5) : []} />
                </Card>
            )}
        </div>
    );
}
